
import { useState } from 'react'
import { useEffect } from 'react';
import LoadCSSforfirstTime from '../../../../../CloudStorage/LoadCSSforfirstTime';
import { useNavigate, useParams } from 'react-router-dom';
import CloudStorage from '../../../../../CloudStorage/CloudStorage';
import { useDispatch, useSelector } from 'react-redux';
import { Commas, getDateFormate } from '../../../../Common/AllDateTimeReleventFormate';
import RentalOrderstatus from './RentalOrderstatus';
import { getRentalRequestById } from '../../../../../redux/rental/action';
import useChatNavigation from '../../../../Common/useChatNavigation';
import { Modal } from 'reactstrap';
import ModelGiveReview from '../../../../Common/ContractandPost/ModelGiveReview';
import HelpSupportModal from '../../../../Common/HelpSupport/HelpSupportModal';
import ProfilePic from "../../../../../assests/imgs/Profileplaceholder.svg";
import ImageWithFallback from '../../../../../common/ImageWithFallback';

export default function ProductforsaleDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { letChat } = useChatNavigation();
  const [review, setReview] = useState(false);
  const [theModal, setTheModal] = useState(false);

  const path = "Assets/scss/FindWork.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);


  const dispatch = useDispatch();

  const od = useSelector(({ rental: { getrentalrequestbyid } }) => getrentalrequestbyid);

  useEffect(() => {
    dispatch(getRentalRequestById(id));
  }, [id]);

  const formatTime = (time) => {
    const [hour, minutes] = time.split(":");
    const date = new Date();
    date.setHours(hour, minutes);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
  };

  return (
    <div className='productsale'>
      <div className="mb-2"
        style={{
          display: "flex",
          alignItems: 'center',
          justifyContent: "space-between",
        }}
      >
        <p className="breadcrumbs">
          <a onClick={() => navigate(-1)} style={{ color: "#ef7710" }}>
            Back &gt;{" "}
          </a>{" "}
          Product details
        </p>
        <button className="background-button btn" onClick={() => setTheModal(true)}>
          Dispute
        </button>
      </div>
      <div className="row justify-content-between">
        <div className="col-md-5">
          <div className='productsale-first'>
            <h2>Order ID: #{id}</h2>
            <div className='order-details'>
              <h6>Order details</h6>
              <div className='orderdetails-p'>
                <p>Order date : <span>{od?.created_on && getDateFormate(od?.created_on)}</span></p>
                <p>Total cost : <span>$ {Commas(od?.total_price)}</span></p>
                <p>Rental type: <span> {od?.rental_type == 2 ? 'Rental With Interpreter' : 'Rental Only'}</span></p>
              </div>
            </div>
            <div className='order-details'>
              <h6>Rental duration (in UTC)</h6>
              <div className='orderdetails-p'>
                <p>Start date & time : <span> {getDateFormate(od?.start_date)}, {od?.start_time && formatTime(od?.start_time)}</span></p>
                <p>End date & time : <span>{od?.end_date && getDateFormate(od?.end_date)}, {od?.end_time && formatTime(od?.end_time)}</span></p>
                <p>Total rental duration:
                  <span>{Commas(od.duration)} {od?.duration_type == 1
                    ? "hour"
                    : od?.duration_type == 2
                      ? "day"
                      : od?.duration_type == 3
                        ? "weeks"
                        : od?.duration_type == 4
                          ? "months"
                          : ""} </span></p>
                <p>Rental price : <span>$ {Commas(od?.price)}/{od?.duration_type == 1
                  ? "hour"
                  : od?.duration_type == 2
                    ? "day"
                    : od?.duration_type == 3
                      ? "weeks"
                      : od?.duration_type == 4
                        ? "months"
                        : ""}</span></p>
              </div>
            </div>


          </div>
          <div className='item-details'>
            <h5>Item details</h5>
            <div className='professional'>
              <ImageWithFallback url={Array.isArray(od?.files) ? od?.files[0]?.file : od?.cover} />
              <div>
                <h6>{od?.title}</h6>
                <h3>$ {Commas(od?.price)} /{od?.duration_type == 1
                  ? "hour"
                  : od?.duration_type == 2
                    ? "day"
                    : od?.duration_type == 3
                      ? "weeks"
                      : od?.duration_type == 4
                        ? "months"
                        : ""}</h3>
              </div>
            </div>
          </div>
          {
            od && (
              <div className='item-details buyer-info'>
                <h5>{od.is_mine == "0" ? "Owner" : "Renter"} info </h5>
                <div className='professional '>
                  <img src={od?.profile_image ? od?.profile_image : ProfilePic} alt="" />
                  <div className='professional-left'>
                    <div>
                      <h6>{od?.first_name} {od?.last_name}</h6>
                      <p className='location'> <img src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`} alt="" /> {od?.country_title} </p>
                    </div>
                    <div>
                      <p className='pb-1'>{od?.email_id} </p>
                      <p>{od?.country_code ? od?.country_code : ''} {od?.mobile_number} </p>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center give-review-sec">
                  <button className="buttons border-button m-0" onClick={() => { letChat(od) }}>
                    <img src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`} alt="" /> Chat with {od.is_mine == "0" ? "Owner" : "Renter"}
                  </button>

                  {(od?.status == 7 && od?.is_mine_expert == 1) &&
                    <>
                      {
                        od?.given_rating > 0 ?
                          <a >
                            Already Reviewed
                          </a>
                          :
                          <a onClick={() => setReview((state) => !state)}>
                            Give Review
                            <img
                              src={`${CloudStorage.cloudurl}Assets/Images/dashboard/square-arrow.svg`}
                              alt=""
                            />
                          </a>
                      }
                    </>
                  }
                </div>
              </div>
            )
          }

        </div>
        <Modal
          size="xl"
          className="popupmodal rent-modal"
          isOpen={review}
          toggle={() => setReview((state) => !state)}
        >
          <ModelGiveReview
            setReview={setReview}
            posts={od}
            type={5}
          />
        </Modal>

        {od?.status > 2 ? <RentalOrderstatus data={od} /> : od?.status == 2 ?
          <div className="col-md-5">
            <div className='status-rightsec reject-sts'>
              <h6>Rejected</h6>
            </div>
          </div>
          : ""}
      </div>
      <HelpSupportModal
        theModal={theModal}
        setTheModal={setTheModal}
        data={od}
        masterID={id}
        masterType="8"
      />
    </div>
  );
}
